export const ACTIVATION_BASE_URL = "/unlock";

export const POD_KEYS_COUNT = 8;

export const POD_KEYS_PATTERN = "[A-Z]";
